// responsible for any overall 'page' changes
// any page change needs to be done via this module,
// instead of using $('body').html()

import * as async from "async";
import $ from "jquery";
import * as preact from "preact";

import PreactSubviewManager from "PreactSubviewManager";
import * as currentDate from "currentDate";
import * as genericModals from "genericModals";
import * as internalLinkHandler from "internalLinkHandler";
import * as modalDialog from "modalDialog";
import models from "models/models";
import * as mustcache from "mustcache";
import * as notificationUtils from "notificationUtils";
import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import * as utils from "shared/utils";
import * as signupModal from "signupModal";
import * as splitTest from "splitTest";
import * as themeColor from "themeColor";
import * as tweets from "tweets";
import * as types from "types";
import * as upsellTimer from "upsellTimer";
import * as urlUtils from "urlUtils";
import EditProfileView from "views/EditProfileView";
import LanguageSelectorView from "views/LanguageSelectorView";
import StreakView from "views/StreakView";
import * as walkthrough from "walkthrough";
import * as webFontLoader from "webFontLoader";
import * as webReaderInstaller from "webReaderInstaller";

let preactSubviewManager: PreactSubviewManager;
let headerAndFooterVisible = false;
let containerElement;
let appRouter;
let page;
let options;
let flashcardHintShownThisSession = false;
let trackedAppLoad = false;

export const init = (_appRouter) => {
  appRouter = _appRouter;

  webFontLoader.init();
  walkthrough.init(models.user);
  notificationUtils.init(models);

  models.user.on("change", () => {
    updateUserViews();
  });
  models.user.on("change:firstLanguage", updateFonts);
  models.user.on("change:currentLearningLanguage", updateFonts);
  models.user.on("change:currentLearningLanguage", updateTabs);
  models.user.on("change:username", (model, username) => {
    if (containerElement) {
      $("#userDropdownList .user-username").text(utils.elide(username, 21));
    }
  });

  window.alert = (message) => {
    genericModals.alert({ message: message });
  };
};

const updatePromoLink = () => {
  // delay to ensure the web reader has time to write the #readlang-extension-installed div
  setTimeout(() => {
    if (
      $(".webReaderInstallerContainer").length > 0 &&
      webReaderInstaller.showInstaller()
    ) {
      $(".webReaderInstallerContainer").addClass("active");
    }
  }, 800);
};

const updateFonts = () => {
  const firstLanguage = languageMap.map[models.user.get("firstLanguage")];
  const currentLearningLanguage =
    languageMap.map[models.user.get("currentLearningLanguage")];

  if (firstLanguage.alphabet) {
    webFontLoader.loadSubset(firstLanguage.alphabet);
  }
  if (currentLearningLanguage.alphabet) {
    webFontLoader.loadSubset(currentLearningLanguage.alphabet);
  }
};

const updateTabs = () => {
  if (
    !models.user.isLocalMode() &&
    languageMap.languageSupportsChat(models.user.get("currentLearningLanguage"))
  ) {
    $(".navTabChat").show();
  } else {
    $(".navTabChat").hide();
  }
};

var updateUserViews = () => {
  $("span[data-userProperty=username]").text(models.user.get("username"));
  $("span[data-userProperty=firstLanguageString]").text(
    languageMap.map[models.user.get("firstLanguage")].english
  );

  const currentLearningLanguageInfo =
    languageMap.map[models.user.get("currentLearningLanguage")];
  $("span[data-userProperty=currentLearningLanguageString]").text(
    currentLearningLanguageInfo.english
  );
};

// route all clickable actions
const clickableHandler = async function (event) {
  event.stopPropagation();
  event.preventDefault();

  let $this = $(this);
  let id = $this.attr("data-clickable");

  if (typeof id === "undefined") {
    id = $this.attr("id");
    if (typeof id === "undefined") {
      return;
    }
  }

  const path = id.split("-");

  if (path[0] === "navWords") {
    if (await readlangClient.isLocalMode()) {
      signupModal.show({
        headingHtml: "<h2>Sign in to manage your words</h2>",
        models: models,
      });
    } else {
      appRouter.navigate($this.attr("href"), { trigger: true });
    }
  } else if (path[0] === "editionDropdown") {
    modalDialog.show("#editionDropdownList", {
      center: false,
      closeButton: false,
      title: "learningLanguage",
    });
    preact.render(null, $("#learningLanguageSelector")[0]);
    preact.render(
      preact.h(LanguageSelectorView, {
        featuredLanguages: models.user.get("activeLanguages"),
        languageType: "learning",
        setLanguage: (languageCode) => {
          models.user.save(
            { currentLearningLanguage: languageCode },
            { patch: true }
          );
          modalDialog.cancel();
        },
      }),
      $("#learningLanguageSelector")[0]
    );
  } else if (path[0] === "firstLanguageDropdown") {
    modalDialog.show("#firstLanguageDropdownList", {
      center: false,
      closeButton: false,
      title: "firstLanguage",
    });
    preact.render(null, $("#firstLanguageSelector")[0]);
    preact.render(
      preact.h(LanguageSelectorView, {
        languageType: "first",
        setLanguage: (languageCode) => {
          models.user.save({ firstLanguage: languageCode }, { patch: true });
          modalDialog.cancel();
        },
      }),
      $("#firstLanguageSelector")[0]
    );
  } else if (path[0] === "userDropdown") {
    const userDropdownList = $("#userDropdownList");
    modalDialog.show(userDropdownList, {
      center: false,
      closeButton: false,
      title: "userDropdown",
      onShow: function () {
        internalLinkHandler.setup(userDropdownList, appRouter);
      },
    });
  } else if (path[0] === "user") {
    if (path[1] === "logout") {
      readlangClient.logout();
    } else if (path[1] === "profile") {
      appRouter.navigate("/user/" + models.user.id, { trigger: true });
      return;
    } else if (path[1] === "password") {
      mustcache.render(
        "changePassword",
        {
          user: models.user.toJSON(),
        },
        (html) => {
          const passwordDialog = $(html);

          passwordDialog.find(".clickable").click(clickableHandler);
          passwordDialog.find('input[name="password2"]').keyup((keyUpEvent) => {
            if (keyUpEvent.which === 13) {
              passwordDialog.find("#user-confirmPassword").click();
            }
          });
          modalDialog.cancel();
          modalDialog.show(passwordDialog, { title: "changePassword" });
        }
      );
    } else if (path[1] === "confirmPassword") {
      const password1 = $("#passwordForm input[name=password1]")
        .val()
        .toString();

      const password2 = $("#passwordForm input[name=password2]")
        .val()
        .toString();

      const oldPassword = $("#passwordForm input[name=oldPassword]")
        .val()
        .toString();

      if (password1.length < 5) {
        alert("password must be at least 5 characters");
      } else if (password1 !== password2) {
        alert("passwords don't match");
      } else {
        readlangClient.request(
          "PUT",
          "/api/user",
          {
            oldPassword: oldPassword,
            newPassword: password1,
          },
          (data) => {
            if (data.error) {
              alert(data.error);
            } else {
              modalDialog.cancel();
              alert("Password changed successfully");
            }
          },
          null,
          { https: true }
        );
      }
    }
  } else if (path[0] === "link") {
    modalDialog.cancel();

    if (path[1] === "forum") {
      window.open("https://forum.readlang.com", "_blank");
    } else {
      appRouter.navigate(path[1], { trigger: true });
    }
  } else if (path[0] === "signUpButton") {
    signupModal.show({
      headingHtml: "<h2>Let's get started!</h2>",
      models: models,
    });
  } else if (path[0] === "loginButton") {
    readlangClient.login();
  }
};

const showProfileDialog = () => {
  const viewElement = $("<div/>");

  // XXX Manage subviews
  new EditProfileView({
    model: models.user,
    el: viewElement,
    finished: function () {
      modalDialog.cancel();
      modalDialog.cancel();
    },
  });

  modalDialog.show($('<div class="centralDialog" />').append(viewElement), {
    title: "account",
  });
};

/** Allows async function */
const onDocumentReady = (asyncCallback) => {
  $(document).ready(() => asyncCallback());
};

let showingRabbitDialog = false;

const showRabbitDialog = () => {
  if (showingRabbitDialog) {
    dismissRabbitDialog();
    return;
  }
  showingRabbitDialog = true;

  splitTest.trackEvent("showRabbitShareDialog");

  $(".rabbitShare .closeDialogButton").click(() => {
    $(".rabbitShare").fadeOut();
  });

  $(".rabbitShare").fadeIn();

  setTimeout(() => {
    document.addEventListener("click", dismissRabbitDialog);
  }, 0);
};

const dismissRabbitDialog = () => {
  $(".rabbitShare").fadeOut();
  document.removeEventListener("click", dismissRabbitDialog);
  showingRabbitDialog = false;
};

// page should have a render function
export const renderPage = (_page: types.Page, _options?) => {
  let newPage = false;

  // close previous page
  if (page && page.name !== _page.name) {
    newPage = true;
    page.close?.();
  }

  modalDialog.cancelAll();

  $(".pageLoading").removeClass("pageLoading");

  page = _page;
  options = _options || {};

  // pre-fetch templates
  mustcache.fetch("mainLayout");

  if (page.showHeader && !headerAndFooterVisible) {
    $("#entirePage").empty();
  }

  async.series([
    (callback) => {
      async.parallel(
        [
          (innerCallback) => {
            if (!models.user.isNew()) {
              innerCallback();
              return;
            }
            models.user.fetch({
              success: function () {
                if (
                  !models.user.get("firstLanguage") ||
                  !models.user.get("currentLearningLanguage")
                ) {
                  showProfileDialog();
                }
                innerCallback();
              },
              error: function () {
                throw "No user!";
              },
            });
          },
          async (innerCallback) => {
            // fetch now so we don't have to wait later
            await currentDate.get();
            innerCallback();
          },
        ],
        () => {
          callback();
        }
      );
    },
    async (callback) => {
      // referral code
      let referrer = urlUtils.getUrlVar("ref", window.location.hash);
      if (referrer) {
        localStorage.setItem("referrer", referrer);
      }

      if (!(await readlangClient.isLocalMode())) {
        referrer = localStorage.getItem("referrer");
        if (referrer) {
          models.user.save(
            { referrer: referrer },
            {
              patch: true,
              success: function () {
                localStorage.removeItem("referrer");
              },
            }
          );
        }
      }

      const userJSON = models.user.viewJSON();

      updateFonts();

      onDocumentReady(async () => {
        const isLocalMode = await readlangClient.isLocalMode();
        const hasSetLanguages =
          walkthrough.hasAchievement("setLanguages") ||
          models.user.get("currentLearningLanguage") !== "es";

        if (isLocalMode && options.skipOnboardingDialogs) {
          // If we're skipping onboarding dialogs for this page, don't then show it on the next
          // page the user visits.
          localStorage.setItem("shownSignup", "true");
        }

        if (
          isLocalMode &&
          !options.skipOnboardingDialogs &&
          !localStorage.getItem("zombieMode") &&
          (!hasSetLanguages || !localStorage.getItem("shownSignup")) &&
          window.location.pathname !== "/start" &&
          window.location.pathname !== "/webReaderSignIn" &&
          !window.location.pathname.startsWith("/startLanguage")
        ) {
          // Reset these since we aren't going to be rendering that page. If we don't do this,
          // then mainLayout will try to call the page.close() function without having rendered it
          // first.
          page = undefined;
          options = undefined;
          appRouter.navigate(
            `/start?redirectPath=${encodeURIComponent(window.location.pathname)}`,
            { trigger: true }
          );
          return;
        }

        let title = page.name.replace("Page", "");
        title =
          title.substring(0, 1).toUpperCase() +
          title.substring(1).replace(/([A-Z])/g, " $1") + // "CamelCase" -> "Camel Case"
          " - Readlang";
        $("title").text(title);

        if (!page.showHeader) {
          $("body").removeClass("showHeader");
          containerElement = $("#entirePage");
          headerAndFooterVisible = false;
          callback();
          return;
        } else if (headerAndFooterVisible) {
          callback();
          return;
        }

        const body = $("body");

        const mustacheData: { [key: string]: any } = {
          languageList: languageMap.list,
          user: userJSON,
        };
        mustacheData.localMode = isLocalMode;

        if (localStorage.getItem("zombieMode")) {
          mustacheData.zombieMode = true;
        }

        if (
          mustacheData.user.subscriptionPlan === "standard" ||
          mustacheData.user.subscriptionPlan === "plus" ||
          mustacheData.user.subscriptionPlan === "freeForever"
        ) {
          mustacheData.user.upgraded = true;
        }

        const dismissFlashcardHint = () => {
          $(".flashcards.tooltip").hide();
          $("#navTest").removeClass("glow");
          walkthrough.setAchievement("flashcardsHint", true);
        };

        mustacheData.user.username = utils.elide(
          mustacheData.user.username,
          21
        );
        mustacheData.tweetText = tweets.fetch(models.user.id);

        if (models.user.isGod()) {
          mustacheData.showAdminPanel = true;
        }

        mustcache.render("mainLayout", mustacheData, async (html) => {
          $("#entirePage").html(html);
          updatePromoLink();
          models.userWords.trigger("groupsUpdated");
          updateUserViews();
          updateTabs();

          body.addClass("showHeader");
          body.find(".clickable").click(clickableHandler);

          $("#navTest").click(dismissFlashcardHint);
          $(".dismissFlashcardHint").click(dismissFlashcardHint);

          $(".readlangLogoContainer").click(() => {
            showRabbitDialog();
          });

          containerElement = $("#mainContent");
          headerAndFooterVisible = true;

          if (await models.user.hasNewStreakFeature()) {
            if (!preactSubviewManager) {
              preactSubviewManager = new PreactSubviewManager();
            }
            preactSubviewManager.add(
              "streak",
              preact.h(StreakView, {
                model: models.streak,
                tooltipParentElement: document.querySelector("#streak"),
              }),
              $("#streak")[0]
            );
            models.streak.fetch();
          }

          callback();
        });
      });
    },
    (callback) => {
      if (navigator.userAgent.match(/Android|iPhone|iPad|iPod/i)) {
        $("body").addClass("touch");
      } else {
        // cspell: disable-next-line
        $("body").addClass("notouch");
      }
      if (newPage) {
        containerElement.addClass("pageLoading");
      }
      page.render(
        containerElement,
        (renderedOptions) => {
          $("#footer").show();
          $("body").attr("id", page.name);
          if (newPage) {
            containerElement.removeClass("pageLoading");
          }
          renderedOptions = renderedOptions || {};

          if (page.showHeader && !renderedOptions.alreadyScrolled) {
            if ($(document).scrollTop() > 0) {
              $("body, html").animate({ scrollTop: 0 });
            }
          }
          // set theme color based on body:
          themeColor.update();

          callback();
          if (!trackedAppLoad) {
            splitTest.trackEventWithProperties("loadApp", {
              page: page.name,
            });
            trackedAppLoad = true;
          }

          if (
            models.user.get("subscriptionPlan") !== "standard" &&
            models.user.get("subscriptionPlan") !== "plus" &&
            models.user.get("subscriptionPlan") !== "freeForever" &&
            upsellTimer.isReady()
          ) {
            const dialog = $("<div/>")
              .addClass("centralDialog")
              .append(
                mustcache.render("socialShare", {
                  tweetText: tweets.fetch(models.user.id),
                })
              );

            internalLinkHandler.setup(dialog, appRouter);

            modalDialog.show(dialog, {
              title: "upsellTimer",
              cancelCallback: function () {
                upsellTimer.reset();
              },
            });
          }

          if (!headerAndFooterVisible) {
            flashcardHintShownThisSession = false;
          }
          if (
            headerAndFooterVisible &&
            !flashcardHintShownThisSession &&
            !/^\/learn/.test(window.location.pathname) &&
            !(
              walkthrough.hasAchievement("flashcards") ||
              walkthrough.hasAchievement("flashcardsHint")
            ) &&
            $(window).width() > 754
          ) {
            flashcardHintShownThisSession = true;
            readlangClient.request(
              "GET",
              "/api/readyToStartFlashcards",
              {
                language: models.user.get("currentLearningLanguage"),
              },
              (data) => {
                if (data.count) {
                  if (data.count > 7) {
                    $(".tooltip-readyToStartCount").text(data.count);
                    $(".flashcards.tooltip").fadeIn();
                    $("#navTest").addClass("glow");
                  }
                } else if (data.error === "alreadyStarted") {
                  walkthrough.setAchievement("flashcards", true);
                }
              }
            );
          }

          if (localStorage.getItem("zombieMode")) {
            $("body").append('<div id="zombieRendered"></div>');
          }
        },
        appRouter,
        options
      );
    },
  ]);
};
